// src/pages/WorkerTerms.js
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_WRK = process.env.REACT_APP_API_WRK; // e.g. http://localhost:5000/api/worker

const WorkerTerms = () => {
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();
  const workerId = localStorage.getItem("workerId");

  const handleAccept = async () => {
    if (!workerId) {
      navigate("/worker-login");
      return;
    }

    try {
      await axios.post(`${API_WRK}/accept-terms`, {
        workerId,
        acceptedAt: new Date(),
      });

      // Optional: reflect immediately in UI pieces that read localStorage
      localStorage.setItem("workerTermsAccepted", "true");

      navigate("/documents");
    } catch (err) {
      console.error("Failed to accept terms:", err);
      alert("Failed to save acceptance.");
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Header */}
      <div className="bg-black text-white p-4 text-xl font-bold">Worker Terms & Conditions</div>

      {/* Terms Box */}
      <div className="flex-1 p-4 overflow-y-auto text-sm text-gray-800 space-y-4 max-h-[60vh]">
        <p><strong>1. Independent Contractor Acknowledgment</strong><br />
        By signing up with Book Your Need ("BYN"), you agree that you are an independent contractor and not an employee of BYN. You are solely responsible for all tax obligations, work permits, and local regulations. BYN will not withhold taxes or provide employment benefits.</p>

        <p><strong>2. Identity & Background Checks</strong><br />
        You agree to submit government-issued identification for background verification, and authorize BYN or its third-party verification services to confirm your identity, eligibility to work, and criminal background (if applicable). Any false information may lead to immediate termination.</p>

        <p><strong>3. Damages & Disputes</strong><br />
        You understand that you are personally liable for any damage, theft, or loss caused during a job due to your actions or negligence. BYN is not responsible for disputes arising between you and the customer. In case of serious conflict, your account may be reviewed or suspended.</p>

        <p><strong>4. Job Responsibility</strong><br />
        You are expected to arrive on time, complete jobs professionally, maintain communication with customers, and avoid cancellations. Repeated cancellations or complaints will negatively affect your rating and job eligibility.</p>

        <p><strong>5. Payment & Commission</strong><br />
        You will be paid through our official channels once the job is marked complete and approved. BYN deducts a commission depending on your tier (Silver: 15%, Gold: 12%, Platinum: 10%). Bonuses and incentives are issued based on performance reviews and company policy.</p>

        <p><strong>6. Safety & Compliance</strong><br />
        You must follow all applicable laws, safety guidelines, and licensing requirements. Unsafe behavior, harassment, or misconduct will lead to immediate termination and possible legal action.</p>

        <p><strong>7. Terms Modification</strong><br />
        BYN reserves the right to modify these terms at any time. You will be notified of changes, and continued use of the platform constitutes your acceptance of the updated terms.</p>

        <p><strong>8. Termination</strong><br />
        BYN may suspend or terminate your access to the platform for any violation of these terms, fraudulent activity, misuse of the platform, or behavior that damages the reputation of BYN or endangers customers.</p>

        <p><strong>9. Legal</strong><br />
        These terms are governed by the laws of your province and local jurisdiction. All legal matters will be resolved through mediation or arbitration before proceeding to court, where possible.</p>

        <p><strong>10. Limitation of Liability</strong><br />
        BYN is not liable for indirect or incidental damages, loss of income, or any claims arising from worker actions or client disputes. BYN acts as a platform to connect workers and customers but does not oversee the actual work performed.</p>

        <p><strong>11. Acknowledgment</strong><br />
        You confirm that you have read, understood, and agreed to abide by these terms and conditions as a prerequisite to accepting jobs through the BYN Worker platform.</p>
      </div>

      {/* Footer - Accept Checkbox and Button */}
      <div className="p-4 border-t">
        <label className="flex items-center space-x-2">
          <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} />
          <span className="text-sm text-gray-800">I have read and agree to the Terms & Conditions above.</span>
        </label>
        <button
          disabled={!agreed}
          onClick={handleAccept}
          className={`mt-4 w-full py-3 rounded-md font-semibold text-white ${
            agreed ? "bg-black hover:bg-gray-800" : "bg-gray-400 cursor-not-allowed"
          }`}
        >
          I Accept
        </button>
      </div>
    </div>
  );
};

export default WorkerTerms;
